import httpClient from "@/tools/http-client";
import {ref} from "vue";
import {useOrdersStore} from "@/store/orders";
import {useRouter} from "vue-router";


export function usePayment() {
    const paymentLoading = ref(false);
    const paymentError = ref(null);
    const ordersStore = useOrdersStore()
    const router = useRouter()
    const handlePayment = async () => {
        paymentLoading.value = true;
        paymentError.value = null;

        try {
            // 1. Отправляем запрос на ВАШ бэкенд
            //  должен вызвать метод Init API Тинькофф и вернуть PaymentURL
            const response = await httpClient.post('/api/v1/payment', {
                order_id: ordersStore.record.id,
            });

            if (response.data.paymentUrl) {
                // 2. Перенаправляем пользователя на страницу оплаты Тинькофф
                sessionStorage.setItem('left_to_external', 'true');
                window.location = response.data.paymentUrl;
            } else {
                throw new Error('Не удалось получить ссылку на оплату');

            }
        } catch (err) {
            paymentError.value = 'Ошибка при создании платежа. Попробуйте позже.';
            console.error('Payment Error:', err);
            await router.push({name: "CheckoutFinishErrorView", params: {err: err}});
        } finally {
            paymentLoading.value = false;
        }
    }
    return {
        handlePayment
    }
}
